import { topSidePartOfWeb } from './parts/sideParts'
import { drawWithImagePatternWrapper } from 'src/util/canvasImagePattern'

const laceOfAllowLiningRight = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.beginPath()
  ctx.moveTo(326 + x, 291 + y) // 左上
  ctx.quadraticCurveTo(330 + x, 299 + y, 330 + x, 299 + y) // 左下
  ctx.quadraticCurveTo(343 + x, 298 + y, 343 + x, 298 + y) // 右下
  ctx.quadraticCurveTo(345 + x, 291 + y, 341 + x, 291 + y) // 右上
  ctx.quadraticCurveTo(326 + x, 291 + y, 326 + x, 291 + y) // 左下
  ctx.fill()
  ctx.moveTo(330 + x, 297 + y) // 左下
  ctx.quadraticCurveTo(343 + x, 296 + y, 343 + x, 298 + y) // 右下
  ctx.stroke()
  ctx.closePath()
}

const laceOfAllowLiningLeft = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.beginPath()
  ctx.moveTo(321 + x, 306 + y) // 左上
  ctx.quadraticCurveTo(324 + x, 313 + y, 324 + x, 313 + y) // 左下
  ctx.quadraticCurveTo(329 + x, 307 + y, 331 + x, 301 + y) // 右下
  ctx.quadraticCurveTo(328 + x, 298 + y, 328 + x, 298 + y) // 右上
  ctx.quadraticCurveTo(321 + x, 306 + y, 321 + x, 306 + y) // 左下
  ctx.fill()
  ctx.moveTo(324 + x, 311 + y) // 左下
  ctx.quadraticCurveTo(327 + x, 305 + y, 331 + x, 300 + y) // 右下
  ctx.stroke()
  ctx.closePath()
}

const w37ArrowLace = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number, rotate: number): void => {
  ctx.save()
  ctx.rotate((rotate * Math.PI) / 180)
  laceOfAllowLiningRight(ctx, laceColor, -27 + x, -75 + y)
  laceOfAllowLiningRight(ctx, laceColor, -21 + x, -60 + y)
  laceOfAllowLiningRight(ctx, laceColor, -15 + x, -45 + y)
  laceOfAllowLiningRight(ctx, laceColor, -10 + x, -30 + y)
  laceOfAllowLiningRight(ctx, laceColor, -5 + x, -15 + y)
  laceOfAllowLiningRight(ctx, laceColor, 0 + x, 0 + y)

  laceOfAllowLiningLeft(ctx, laceColor, -25 + x, -75 + y)
  laceOfAllowLiningLeft(ctx, laceColor, -20 + x, -60 + y)
  laceOfAllowLiningLeft(ctx, laceColor, -15 + x, -45 + y)
  laceOfAllowLiningLeft(ctx, laceColor, -10 + x, -30 + y)
  laceOfAllowLiningLeft(ctx, laceColor, -5 + x, -15 + y)
  laceOfAllowLiningLeft(ctx, laceColor, 0 + x, 0 + y)

  ctx.restore()
}

export const w37Web = async (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  laceColor: string,
  stitchColor: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'

  // ウェブ本体
  const drawMainPath = () => {
    ctx.beginPath()
    ctx.moveTo(300, 376) // 左下
    ctx.quadraticCurveTo(339, 334, 373, 252) // 右下
    ctx.quadraticCurveTo(384, 159, 359, 92) // 右上
    ctx.quadraticCurveTo(269, 153, 210, 260) // 左上
    ctx.quadraticCurveTo(300, 376, 300, 376) // 左下
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawMainPath, webColor)

  ctx.lineWidth = 2.0
  ctx.beginPath()
  ctx.moveTo(261, 231) // 左下
  ctx.quadraticCurveTo(336, 267, 336, 267) // 右下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.lineWidth = 1.3
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])

  ctx.moveTo(346, 115)
  ctx.quadraticCurveTo(318, 158, 363, 220)
  ctx.quadraticCurveTo(295, 187, 307, 148)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()

  ctx.moveTo(255, 298)
  ctx.quadraticCurveTo(281, 319, 323, 307)
  ctx.quadraticCurveTo(296, 336, 282, 330)

  // ctx.moveTo()
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  ctx.lineWidth = 1.0

  w37ArrowLace(ctx, laceColor, -285, 120, -45)
  // ウェブ先端
  await topSidePartOfWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
}
